var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"con"},[_c('img',{attrs:{"src":require("../../assets/img/LoginSuccessLogo.png"),"alt":""}}),_c('p',[_vm._v("微信认证成功")])])
}]

export { render, staticRenderFns }